<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Clientes</h2>
    </div>


    <tds-accordion>
        <!-- Filtros -->
        <tds-accordion-item header="Filtros" aria-level="6" expanded>
            <div class="tds-row">
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Informe a razão social" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 20px; width: 25%"></tds-text-field>
                <tds-button type="button" variant="primary" size="lg" text="Pesquisar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
            </div>
        </tds-accordion-item>

        <!-- Tabela -->
        <tds-accordion-item header="Tabela" aria-level="6" expanded>
            <div class="tds-row">
                <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
                    <tds-table-toolbar>
                        <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                            <tds-button variant="secondary" size="sm" title="Inserir">
                                <tds-icon slot="icon" class="tds-btn-icon" size="18px" name="plus"></tds-icon>
                            </tds-button>
                        </div>
                    </tds-table-toolbar>
                    <tds-table-header>
                        <tds-header-cell cell-key="actions"></tds-header-cell>
                        <tds-header-cell cell-key='coD_ORIGINAL' cell-value='Código' sortable></tds-header-cell>
                        <tds-header-cell cell-key='razaoSocial' cell-value='Razão Social' sortable></tds-header-cell>
                    </tds-table-header>
                    <tds-table-body>
                        <tds-table-body-row>
                            <tds-body-cell cell-key="actions">
                                <div class="action-buttons" title="Excluir">
                                    <tds-icon id="edit" name="cross" size="20px" style="cursor: pointer;" ></tds-icon>
                                </div>
                            </tds-body-cell>
                            <tds-body-cell cell-key="coD_ORIGINAL">12344</tds-body-cell>
                            <tds-body-cell cell-key="descr">A A COMERCIO DE FRIOS E TRANPORT</tds-body-cell>
                        </tds-table-body-row>
                    </tds-table-body>
                </tds-table>
            </div>
        </tds-accordion-item>
    </tds-accordion>
    
</div>